import SubscriptionsContainerReducer from './SubscriptionsContainerReducer';

export const SubscriptionsContainerReducers = {
  SubscriptionsContainerReducer,
};
export * as actions from './SubscriptionsContainerActions';
